import React from "react";

// reactstrap components
import {
    Badge,
    Button,
    Container,
    Card,
    CardBody,
    CardFooter,
    CardImg,
    CardImgOverlay,
    CardLink,
    CardTitle,
    CardSubtitle,
    CardText,
    ListGroupItem,
    ListGroup,
    Row,
    Col,
    
  } from "reactstrap";
  
function SelectSchool(props){
    const {listOfSchoolsByRegion, user, onClickOfSchool,product} = props;
    const selectedSchool  = user.school;   
    
    React.useEffect(()=>{
     // window.scrollTo(0, 0);
     // document.body.scrollTop = 0;
      document.getElementById("mainContentArea").scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    });
    
    return(
        <Container id="mainContentArea">
          <Row className="title-row justify-content-between">
            <Col>
              <h1 className="shop">Signup for Laundry - Student</h1>
            </Col>
          </Row>
          <Row className="title-body-row">
                <Col md="12">
                    {
                        listOfSchoolsByRegion.map(region=>{
                        return(
                            <div key={region.id}>
                                <hr />
                                    <div className="school-region-title" >
                                      {region.name}
                                    </div>
                                <hr />
                                <Row className="card-body-row">
                                {
                                region.schools.map(school =>{
                                        const selectedAttributes = (selectedSchool && selectedSchool.id === school.id) ? {"data-color":"orange"}:{};
                                        
                                        /*
                                        let backgroundImage = {
                                          backgroundImage: ""
                                        }
                                        let flagImage = require("assets/mylazybones/img/placeholder_img.png");

                                        if(school.id === 6){
                                           backgroundImage = {
                                            backgroundImage: "url(" +
                                            require("assets/mylazybones/img/uw_madison.jpg") +
                                            ")"
                                          }
  
                                           flagImage = require("assets/mylazybones/img/uw_madison_flag.png");
                                        }

                                        if(school.id === 5){
                                          backgroundImage = {
                                           backgroundImage: "url(" +
                                           require("assets/mylazybones/img/syracuse_univ.jpg") +
                                           ")"
                                         }
 
                                          flagImage = require("assets/mylazybones/img/syracuse_univ_flag.png");
                                       }
                                       */

                                        let backgroundImage = {
                                          backgroundImage: ""
                                        }
                                        
                                        let flagImage = "";
                                        try{
                                          flagImage = require(`assets/mylazybones/img/signup/school/${school.id}.jpg`);
                                        }
                                        catch(ex){
                                          flagImage = require(`assets/mylazybones/img/signup/school/generic_school.jpg`);
                                        }
                                        
                                        backgroundImage = {
                                          backgroundImage: "url(" +
                                            flagImage + 
                                          ")"
                                        }

                                       
                                        const isSchoolSelected = (selectedSchool && selectedSchool.id === school.id) 
                                          ? true:false;

                                        return(
                                            <Col key={school.id} md="4" sm="4">
                                                {/* need to add card-profile to the class below if we need background */}
                                                <Card className="card-profile cursor mt-0" {...selectedAttributes} onClick={e => onClickOfSchool(school,product)}>
                                                  <div
                                                    className="card-cover"
                                                    style={backgroundImage}
                                                  />
                                                  <CardBody>
                                                    <CardTitle className="school-region-card-title">
                                                      {isSchoolSelected ? <strong>{school.name}</strong>:school.name }
                                                    </CardTitle>
                                                    { 
                                                      (selectedSchool && selectedSchool.id === school.id) &&
                                                      <CardFooter className="text-center mt-2">
                                                        { (selectedSchool && selectedSchool.id === school.id) ?
                                                          <Badge className="mr-1" color="success" pill>
                                                            Selected
                                                          </Badge>
                                                          :
                                                          <br/>
                                                        }
                                                      </CardFooter>
                                                    }
                                                  </CardBody>
                                                </Card>
                                            </Col>
                                        );     
                                }) 
                                }
                                </Row>
                                

                            </div>      
                        )


                        })    

                    }
                </Col>
                
          </Row>
          
          
        
      </Container>      
    );
}

export default SelectSchool